
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';
import { seedData } from '@/lib/seedData';

const SeedDataButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSeedData = async () => {
    setIsLoading(true);
    try {
      const result = await seedData();
      
      if (result) {
        toast({
          title: "Data seeded successfully",
          description: "Sample listings have been added to the database",
          duration: 5000,
        });
      } else {
        toast({
          title: "Error seeding data",
          description: "There was a problem adding sample data",
          variant: "destructive",
          duration: 5000,
        });
      }
    } catch (error) {
      toast({
        title: "Error seeding data",
        description: "An unexpected error occurred",
        variant: "destructive",
        duration: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button 
      onClick={handleSeedData} 
      disabled={isLoading}
      className="w-full"
    >
      {isLoading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Creating data...
        </>
      ) : (
        'Create Sample Listings'
      )}
    </Button>
  );
};

export default SeedDataButton;
